<template>
    <div><DisplayDNX :value="computedValue" /></div>
</template>
<script setup lang="ts">
/**
 * This is used to concolidate the exitstatuses and show the one that is most relevant ( only one should be selected, but they are in x ampount of fields on the row)
 */

import { computed } from 'vue';
import DisplayDNX from '../Basic/DisplayDNX.vue';
import { RaceContestant, type ExitStatus } from '@/objects/generated';

const props = defineProps<{
    row: RaceContestant;
}>();

const computedValue = computed<ExitStatus | null>(() => {
    if (props.row.DNF) {
        return 'DNF';
    } else if (props.row.DNS) {
        return 'DNS';
    } else if (props.row.DSQ) {
        return 'DSQ';
    } else if (props.row.DNQ) {
        return 'DNQ';
    } else if (props.row.DNC) {
        return 'DNC';
    } else if (props.row.COMPLETED) {
        return 'Finished';
    } else if (props.row.LAP) {
        return 'LAP';
    } else if (props.row.REL) {
        return 'REL';
    } else {
        return null;
    }
});
</script>
